class BasicRule {
    checkLength (length,errorMsg) {
        return (rule, value, callback) => {
            if(value.length > length) {
                return callback(new Error(errorMsg));
            }
            return callback();
        };
    }
	
    checkEmail () {
        return (rule, value, callback) => {
            var reg =  /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\W_!@#$%^&*`~()-+=]+$)(?![0-9\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\W_!@#$%^&*`~()-+=]{11,}$/;
            if(!reg.test(value)) {
                return callback(new Error("Illegal mailbox."));
            }
            return callback();
        };
    }
	
    checkPw () {
        return (rule, value, callback) => {
            var reg =  /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\W_!@#$%^&*`~()-+=]+$)(?![0-9\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\W_!@#$%^&*`~()-+=]{11,}$/;
            if(!reg.test(value)) {
                return callback(new Error("The password must be at least 11 characters long and contain at least three of the four types: uppercase letters, lowercase letters, special characters and digits."));
            }
            return callback();
        };
    }
	
    checkChinese () {
        return (rule, value, callback) => {
            var reg = /[\u4e00-\u9fa5]/;
            if(reg.test(value)) {
                return callback(new Error("Must not contain Chinese characters."));
            }
            return callback();
        };
    }
}

export { BasicRule };
